import React, { useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FaExclamationCircle } from "react-icons/fa";
import { useUser } from "./UserContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import apiClient from "../Login/apiClient";
import { ToastContainer, toast } from "react-toastify";

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 70vh;
`;

const TopStyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 5vh;
`;

const StyledButton = styled(Button)`
  width: 250px;
  height: 40px;
  font-size: 20px;
`;
const SecondaryStyledButton = styled(Button)`
  background-color: black;
  width: 250px;
  height: 40px;
  font-size: 20px;
  &:hover {
    background-color: #333333;
  }
`;

const StyledLink = styled(Link)`
  color: white;
`;

const StyledCheckMark = styled(FaExclamationCircle)`
  color: black;
  font-size: 70px;
`;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function DeleteAccount() {
  const navigate = useNavigate();

  const { user, setUser, setIsLoggedIn } = useUser(); // ここで修正: useUserフックからuserを直接取得

  // ログアウト処理
  const logout = () => {
    localStorage.clear();
    setUser(null);
    setIsLoggedIn(false);
    // ログアウト後にログイン画面に遷移する
    navigate("/login", {
      state: { message: "アカウント削除が完了しました！" },
    });
  };

  const handleDeleteAccount = async () => {
    try {
      await apiClient.delete(`${API_BASE_URL}/api/accounts/delete-account/`, {});
      logout();
    } catch (error) {
      const errorCode = error?.response?.status;

      if (errorCode === 400) {
        toast.info("入力内容に誤りがあります。");
      } else if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    }
  };

  return (
    <StyledContainer>
      <h2>本サイトを退会しますか？</h2>
      <br />
      <StyledCheckMark />
      <h4>
        <br />
        引き返す方は、「トップページに戻る」ボタンを押下してください。
        <br />
        退会される方は、「退会する」を押下してください。
      </h4>
      <TopStyledContainer></TopStyledContainer>
      <StyledLink to="/">
        <SecondaryStyledButton variant="primary" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", borderColor: "transparent" }}>
          トップページに戻る
        </SecondaryStyledButton>
      </StyledLink>
      <br />
      <StyledButton variant="danger" type="submit" block className="w-90 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "80px", whiteSpace: "nowrap", fontSize: "1.2rem", color: "#ffffff", borderColor: "transparent" }} onClick={handleDeleteAccount}>
        退会する
      </StyledButton>
      <ToastContainer position="top-center" autoClose={3000} />
    </StyledContainer>
  );
}

export default DeleteAccount;
